import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  computed,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconInduxtryComponent } from 'src/app/shared/components/common/icon-induxtry/icon-induxtry.component';
import type { DashboardData } from '../dashboard-stats/dashboard-stats.component';
import { STATUS_COLORS, STATUS_ICONS, STATUS_LABELS, STAGE_COLORS } from '../../models/conexoes.model';
import { StepInterface } from '../../services/detail-connected-item.service';

@Component({
  selector: 'app-pipeline-stage-card',
  imports: [CommonModule, IconInduxtryComponent],
  templateUrl: './pipeline-stage-card.component.html',
  styleUrls: ['./pipeline-stage-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PipelineStageCardComponent {
  title = input('');
  subtitle = input('');
  status = input<keyof typeof STATUS_ICONS>('notDone');
  dashboardData = input<DashboardData | null>(null);
  isLoading = input(false);
  isSelected = input(false);
  disabled = input(false);
  steps = input<StepInterface | null>(null);
  showStats = input(true);
  /** Quando true e status for 'processing', exibe o botão "Acompanhar logs". */
  showFollowLogsButton = input(false);

  cardClick = output<void>();
  followLogsClick = output<void>();

  readonly statusIconMap = STATUS_ICONS;
  readonly statusLabel = computed(() => STATUS_LABELS[this.status()]);
  readonly colorsTypes = signal<Record<string, string>>(STATUS_COLORS);
  readonly stageColors = signal<Record<string, string>>(STAGE_COLORS);

  constructor() {
  }

  formatNumber(value: number | null | undefined): string {
    if (value === null || value === undefined) return '-';
    return value.toLocaleString('pt-BR', { maximumFractionDigits: 2 });
  }

  getValue(value: number | null | undefined): string {
    if (value === null || value === undefined) return '-';
    return value.toString();
  }

  onCardClick(): void {
    if (!this.disabled()) {
      this.cardClick.emit();
    }
  }

  onFollowLogsClick(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    this.followLogsClick.emit();
  }
}
